export default "__VITE_ASSET__e6c80cb0__"